import React from 'react';
import Paginator from '../../components/Paginator';
import { formatDate, formatDateShort } from '../../lib/formatters';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from '../../components/ui/table';

export default function ExportIndex({ exports, pageTranslations: translations }) {
    const hasExports = exports.data && exports.data.length > 0;

    return (
        <div className="max-w-[1200px] mx-auto px-4">
            <div className="rounded-[3px] border border-[#bbb] bg-white">
                <div className="p-[30px]">
                    <h3 className="text-2xl font-bold text-[#003545] mb-4">{translations.overview.title}</h3>
                    <p className="text-sm text-[#003545]">{translations.overview.subtitle}</p>
                </div>

                <div className="px-[30px] pb-[30px]">
                    <Table>
                        <TableHeader className="bg-[#ededed] [&_tr]:border-b-2 [&_tr]:border-[#d4d4d4]">
                            <TableRow className="hover:bg-[#ededed]">
                                <TableHead className="py-6 px-2.5 text-[#003545] font-normal text-sm">{translations.headers.export_created}</TableHead>
                                <TableHead className="py-6 px-2.5 text-[#003545] font-normal text-sm">{translations.headers.status}</TableHead>
                                <TableHead className="py-6 px-2.5 text-[#003545] font-normal text-sm">{translations.headers.filters}</TableHead>
                                <TableHead className="py-6 px-2.5 text-[#003545] font-normal text-sm">{translations.headers.expires}</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {hasExports ? (
                                exports.data.map((exportItem, index) => (
                                    <TableRow key={exportItem.id} className={index % 2 === 1 ? 'bg-[#f5f5f5]' : ''}>
                                        <TableCell className="py-6 px-2.5 whitespace-nowrap">
                                            {exportItem.created_at
                                                ? formatDate(exportItem.created_at, { seconds: true, shortYear: false })
                                                : '-'}
                                        </TableCell>
                                        <TableCell className="py-6 px-2.5">
                                            {exportItem.completed_at ? (
                                                <a href={`/exports/${exportItem.id}/download`} className="inline-flex items-center h-[44px] rounded-[6px] border-2 border-[#ededed] px-6 text-[14px] font-black text-[#003545] hover:bg-[#ededed] transition-colors">
                                                    {translations.download_export}
                                                </a>
                                            ) : (
                                                <span className="text-[#003545] italic">
                                                    {translations.busy}
                                                </span>
                                            )}
                                        </TableCell>
                                        <TableCell className="py-6 px-2.5">
                                            <SearchParameters
                                                params={exportItem.search_parameters}
                                                translations={translations}
                                            />
                                        </TableCell>
                                        <TableCell className="py-6 px-2.5 whitespace-nowrap">
                                            {exportItem.expires_at ? (
                                                <span className="font-bold">{formatDateShort(exportItem.expires_at)}</span>
                                            ) : (
                                                <span>-</span>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={4} className="py-6 px-2.5 text-center text-gray-500">
                                        {translations.no_exports_found}
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>

                    <Paginator links={exports.links} />
                </div>
            </div>
        </div>
    );
}

function SearchParameters({ params, translations }) {
    if (!params || Object.keys(params).length === 0) {
        return <span>{translations.filter.none}</span>;
    }

    return (
        <ul className="list-none m-0 p-0">
            {Object.entries(params).map(([key, value]) => (
                <li key={key}>
                    <b>{translations.filter[key] ?? key}:</b> {value}
                </li>
            ))}
        </ul>
    );
}


